import { __assign as o } from "./_virtual/_tslib.js";
import { forwardRef as r, useContext as t, useImperativeHandle as m } from "react";
import { theSamePair as e, nearPair as s } from "./utils/compare.js";
import i from "./utils/clone.js";
import { useBindProp as n } from "./hooks/props.js";
import { lngLat2Array as a } from "./utils/convert.js";
import { getInitialOptionsFromProps as f } from "./utils/options.js";
import p from "./hooks/component.js";
import c from "./hooks/common/visible.js";
import l from "./hooks/common/z-index.js";
import u from "./hooks/common/click.js";
import j from "./hooks/common/mouse.js";
import k from "./hooks/common/touch.js";
import h from "./hooks/common/opacity.js";
import L from "./hooks/common/zooms.js";
import { LabelsLayerContext as b } from "./LabelsLayer.js";
var v = r(function (r, v) {
  var d = t(b),
      w = p({
    init: function init(t) {
      return new t.LabelMarker(o(o({}, f(r)), {
        position: i(r.position)
      }));
    },
    add: function add(o, r) {
      if (!d) throw new Error("LabelMarker 必须与 LabelsLayer 配合使用");
      d.add(r);
    },
    remove: function remove(o, r) {
      if (!d) throw new Error("LabelMarker 必须与 LabelsLayer 配合使用");
      d.remove(r);
    }
  }, r);
  return m(v, function () {
    return w;
  }, [w]), c(w, r), l(w, r), h(w, r), L(w, r), u(w, r), j(w, r), k(w, r), n(w, {
    setter: "setName"
  }, r.name), n(w, {
    setter: "setRank"
  }, r.rank), n(w, {
    equals: e,
    setter: function setter(o, r) {
      if (r) {
        var t = a(o.getPosition());
        s(r, t) || o.setPosition([r[0], r[1]]);
      }
    }
  }, r.position), n(w, {
    setter: "setIcon"
  }, r.icon), n(w, {
    setter: "setText"
  }, r.text), null;
});
export default v;